import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { 
	FaCoffee, 
	FaCss3, 
	FaCat, 
	FaQuestionCircle, 
	FaReact, 
	FaPython, 
	FaDocker,
	FaMusic,
	FaCopy,
	FaHtml5,
	FaJs,
	FaProjectDiagram,
} from "react-icons/fa"
import "./index.css"
import underDino from "../images/underDino.jpeg"

import Sidebar from "../components/sidebar/Sidebar"
// import TechTag from "../components/tags/TechTag"

const AboutPage = (props) => {
	const labels = props.data.site.siteMetadata.labels
	const aboutTags = ["react", "nodejs", "html", "css"]
	const tags = {}
	labels.forEach(label => {
		aboutTags.forEach(tag => {
			if (tag === label.tag) {
				tags[tag] = label.name
			}
		})
	})
	return (
		<Layout>
		<SEO title="About" />
		<div className="post-page-main">
			<div className="sidebar px-4 py-2">
				<Sidebar />
			</div>
		<div className="post-list-main">
		<div className="container">
			<div className="row">
				<div className="col">
			<h2 className="heading mt-5 border-bottom pb-3 display-4">안녕하세요, 저는</h2>
			<p>이 경호입니다.리노<span className="text-muted">Linus</span>는 세례명입니다.<br /></p>
			<p>눈에 결과가 보이는 작업을 좋아합니다. 다른 사람과 모여서 코딩할때 편안함을 느낍니다. 오늘보다 내일의 자신이 더 나아질 것을 믿습니다.</p>
		{/* ----------------------------------------------------- */}
		<h4 className="py-3 border-bottom">좋아하는 것</h4>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaCss3 size={26} style={{ color: "red" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">CSS IS AWESOME</p>
		</div>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaCoffee size={26} style={{ color: "orange" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">Coffee</p>
		</div>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaMusic size={26} style={{ color: "#2f2f2f" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">Music</p>
		</div>
		{/* ----------------------------------------------------- */}
		<h4 className="py-3 border-bottom">하고 싶은 것</h4>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaReact size={26} style={{ color: "skyblue" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">React Native</p>
		</div>

		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaDocker size={26} style={{ color: "red" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">Docker</p>
		</div>
		{/* ----------------------------------------------------- */}
		<h4 className="py-3 border-bottom">할 수 있는 것</h4>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaPython size={26} style={{ color: "blue" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">Python & Django <span className="ml-3 text-success" style={{fontFamily:"Impact" }}>Lv.30</span></p>
		</div>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaCat size={26} style={{ color: "#2f2f2f" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">고양이 기르기 <span className="ml-3 text-danger" style={{fontFamily:"Impact" }}>Lv.MAX</span></p>
		</div>
		<div>
		<span className="text-success d-inline-block" title="blazing">
		<FaCopy size={26} style={{ color: "success" }} />
		</span>
		<p className="d-inline-block ml-3 w-75 align-top">Ctrl-C + Ctrl-V <span className="ml-3 text-danger" style={{fontFamily:"Impact" }}>Lv.75</span></p>
		</div>
		<div>
		<span className="text-success d-inline-block" title="blazing">
		<FaQuestionCircle size={26} style={{ color: "royalblue" }} />
		</span>
		<p className="d-inline-block ml-3 w-75 align-top">내가 쓴 코드 못 읽기 <span className="ml-3 text-primary" style={{fontFamily:"Impact" }}>Lv.43</span></p>
		</div>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaJs size={26} style={{ color: "orange" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">자바스크립트 <span className="ml-3 text-warning" style={{fontFamily:"Impact" }}>Lv.15</span></p>
		</div>
		<p></p>
		{/* ----------------------------------------------------- */}
		<h4 className="py-3 border-bottom">했던 것</h4>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaHtml5 size={26} style={{ color: "orange" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">SSAFY Web Track 교육 (2019~)</p>
		</div>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaProjectDiagram size={26} style={{ color: "royalblue" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">맞춤형 영화 추천 웹 앱 <a target="_blank"  rel="noopener noreferrer" href="http://15.165.19.28/">Inspiration</a> </p>
		</div>
		<div>
			<span className="text-success d-inline-block" title="blazing">
				<FaProjectDiagram size={26} style={{ color: "royalblue" }} />
			</span>
			<p className="d-inline-block ml-3 w-75 align-top">Chrome extension-new tab <a target="_blank"  rel="noopener noreferrer" href="https://github.com/dodonmountain/DevNewTap">SSAFY new tab</a> </p>
		</div>
		</div>
		<div className="col-md-5">
			<img className="mt-5 about-pic" src={underDino} alt="" />
		</div>
		</div>
		</div>
		</div>
		</div>
		</Layout>
		)
	}
	
	export const pageQuery = graphql`
	query aboutQuery {
		site {
			siteMetadata {
				labels {
					tag
					tech 
					name 
					size 
					color
				}
			}
		}
	}
	`
	
	export default AboutPage
	
	